"use client";

import { useStore } from "@/hooks/use-store";
import styles from "./ModalConfirm.module.scss";
import { useEffect } from "react";

const ModalConfirm = () => {
  const { modalConfirm } = useStore();

  useEffect(() => {
    const body = document.querySelector("html");

    if (modalConfirm.active !== null) {
      body?.classList.add("disable-scroll");
    } else {
      body?.classList.remove("disable-scroll");
    }
  }, [modalConfirm.active]);

  const handleCloseModal = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target === e.currentTarget) {
      modalConfirm.close();
    }
  };

  return (
    <>
      {modalConfirm.active && (
        <div className={`${styles.dialog} ${styles.active}`}>
          <div className={styles.dialog__wrapper}>
            <div onClick={handleCloseModal} className={styles.dialog__inner}>
              <div className={styles.dialog__content}>
                {modalConfirm.showCloseButton && (
                  <button
                    className={styles.close_btn}
                    onClick={() => {
                      modalConfirm.close();
                    }}
                  >
                    <svg
                      viewBox="0 0 14 14"
                      fill="currentColor"
                      width="18"
                      height="100%"
                      className={styles.close_btn__icon}
                    >
                      <use href="/images/sprite.svg#close"></use>
                    </svg>
                  </button>
                )}
                {modalConfirm.active}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ModalConfirm;
